import type { CreateDepartmentRequest, DepartmentSummary, UpdateDepartmentRequest } from '@todo/shared';
import { del, get, patch, post } from './client';

export const departmentApi = {
  /** GET /api/departments - alphabetical; every signed-in user may read. */
  list(): Promise<DepartmentSummary[]> {
    return get<DepartmentSummary[]>('/departments');
  },

  /** POST /api/departments - people.manage only; 409 on a duplicate name. */
  create(body: CreateDepartmentRequest): Promise<DepartmentSummary> {
    return post<DepartmentSummary>('/departments', body);
  },

  /** PATCH /api/departments/:id - rename. */
  update(id: string, body: UpdateDepartmentRequest): Promise<{ id: string; name: string }> {
    return patch<{ id: string; name: string }>(`/departments/${id}`, body);
  },

  /** DELETE /api/departments/:id - soft delete; members keep their history. */
  remove(id: string): Promise<void> {
    return del(`/departments/${id}`);
  },
};
